import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { FormsService, GetFormResponse } from "./../../../services/forms";

import { GetFormRequestActionType, IForm } from "./../types";
import {
    setCurrentForm,
    getFormFailure,
    getUserFontsRequest,
    setFormStyles,
    initFormButtons,
    getFormSuccess,
} from "./../actionCreators";
import {
    completeFieldsData,
    completeFormButtonsStyles,
    completeFormSetting,
    completeFormStyles,
    getCompletedPaymentData,
} from "../../../helpers/dataManipulations";
import { IErrorType } from "./../../types/errors.d";
import { InitPages } from "./../../pages/actionCreators";
import { initFields } from "./../../fields/actionCreators";
import { initLayout } from "./../../layout/actionCreators";
import { initMarkers } from "../../markers/actionCreaters";
import { InitLogic } from "../../logic/actionCreators";
import { initConfigs } from "./../../configs/actionCreators";
import { initOptions } from "./../../selectableOptions/actionCreaters";
import { initUI } from "./../../ui/actionCreators";
import { initValidationMessages } from "../../validations/actionCreators";
import { getDeclarablePaymentData } from "../../../helpers/paymentActions";
import { initFormSettings } from "../../settings/actionCreators";
import { getDeclarableFormButtonsData } from "../../../helpers/submitButton";
import { initPayableFields, initPaymentData } from "../../payment/actionCreators";

export function* getFormSaga({ payload: { id } }: GetFormRequestActionType) {
    try {
        const {
            data: { data },
        }: GetFormResponse = yield FormsService.getForm(id);
        yield put(
            setCurrentForm({
                _id: data._id,
                name: data.name,
                status: data.status,
                createdAt: data.createdAt,
                updatedAt: data.updatedAt,
                integrations: data.integrations,
            } as IForm),
        );


        console.log("Get Form Data 1 : " , data);
        
        yield put(initFormSettings(completeFormSetting(data.settings)));
        yield put(setFormStyles(completeFormStyles(data.styles)));
        yield put(InitPages({ list: data.pages }));
        console.log("Get Form Data  2: " , data);

        
        yield put(initFields({ list: completeFieldsData(data.fields) }));
        yield put(initLayout(data.layout));
        yield put(initMarkers({ list: data.fields }));
        yield put(initUI({ isPaginationActive: data.isPaginationActive, isVerticalView: data.isVerticalView }));
        yield put(initOptions({ list: data.fields }));
        yield put(InitLogic(data.logic));
        yield put(initConfigs(data));
        console.log("Get Form Data 3: " , data);

        yield put(getUserFontsRequest({}));
        yield put(initValidationMessages(data.validations));
        yield put(initPayableFields({ list: data.fields, paymentSettings: data.paymentSettings! }));
        yield put(initFormButtons(getDeclarableFormButtonsData(completeFormButtonsStyles(data.styles.buttons))));
        yield put(
            initPaymentData(
                getDeclarablePaymentData(getCompletedPaymentData(data.paymentSettings ? data.paymentSettings : {})),
            ),
        );
        console.log("Get Form Data 4: " , data);

        yield put(getFormSuccess({ ownerId: data.userId }));
        console.log("Get Form Data 5: " , data);
    } catch (error) {
        console.log("Error", error);
        if (axios.isAxiosError(error))
            yield put(getFormFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(getFormFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
